// Generated by scripts/build-icons.js from the installed Font Awesome icon packs.
// Do not edit by hand.
import type { FaIcon } from 'shared/components/icon';

export const falMinus = {"name":"minus","type":"fal","definition":[448,512,"minus","M0 256c0-8.8 7.2-16 16-16l416 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 272c-8.8 0-16-7.2-16-16z"]} as const satisfies FaIcon;
